/** UTC day/month/year bounds as ISO strings (replaces moment.utc() usage). */

function utcAt(
  year: number,
  monthIndex: number,
  day: number,
  hour: number,
  minute: number,
  second: number
): string {
  return new Date(Date.UTC(year, monthIndex, day, hour, minute, second)).toISOString();
}

function parts(date: Date = new Date()) {
  return {
    y: date.getUTCFullYear(),
    m: date.getUTCMonth(),
    d: date.getUTCDate(),
  };
}

export function utcStartOfDay(date: Date = new Date()): string {
  const { y, m, d } = parts(date);
  return utcAt(y, m, d, 0, 0, 0);
}

export function utcEndOfDay(date: Date = new Date()): string {
  const { y, m, d } = parts(date);
  return utcAt(y, m, d, 23, 59, 59);
}

export function utcStartOfMonth(date: Date = new Date()): string {
  const { y, m } = parts(date);
  return utcAt(y, m, 1, 0, 0, 0);
}

export function utcEndOfMonth(date: Date = new Date()): string {
  const { y, m } = parts(date);
  // day 0 of next month = last day of this month
  const lastDay = new Date(Date.UTC(y, m + 1, 0)).getUTCDate();
  return utcAt(y, m, lastDay, 23, 59, 59);
}

export function utcStartOfYear(date: Date = new Date()): string {
  const { y } = parts(date);
  return utcAt(y, 0, 1, 0, 0, 0);
}

export function utcEndOfYear(date: Date = new Date()): string {
  const { y } = parts(date);
  return utcAt(y, 11, 31, 23, 59, 59);
}

export function utcAddDays(date: Date, days: number): Date {
  const next = new Date(date.getTime());
  next.setUTCDate(next.getUTCDate() + days);
  return next;
}

export function utcAddMonths(date: Date, months: number): Date {
  const next = new Date(Date.UTC(date.getUTCFullYear(), date.getUTCMonth() + months, 1));
  return next;
}

export function utcAddYears(date: Date, years: number): Date {
  return new Date(Date.UTC(date.getUTCFullYear() + years, date.getUTCMonth(), date.getUTCDate()));
}

export function formatUtcYmd(value: string | Date): string {
  const d = value instanceof Date ? value : new Date(value);
  const y = d.getUTCFullYear();
  const m = String(d.getUTCMonth() + 1).padStart(2, '0');
  const day = String(d.getUTCDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
}
